export default "__VITE_ASSET__a4c8794f__"